<div class="card" [class.checked]="checked">
  @if (checked) {
    <i class="fa fa-check-circle"></i>
  }
  <h4 class="card-title">{{ title }}</h4>
  <ng-content></ng-content>
</div>
